module.exports = __webpack_public_path__ + "img/sh.79262eae.jpg";